export const BASE_URL = "https://uat.o4shrsetu.com/api";
// export const BASE_URL = "https://localhost:7193/api";
